module.exports = __webpack_public_path__ + "static/media/ic-pointer-right.1ec5d691.svg";